/**
 * Part 2 — merge VenueProduct.nominalCode onto receipting rows for Xero.
 * Mirrors server/src/utils/attachNominalCodesToReceiptingProducts.js
 */

const toId = value => {
  if (value == null || value === '') return ''
  if (typeof value === 'object') {
    const id = value._id ?? value.id
    return id == null || id === '' ? '' : String(id)
  }
  return String(value)
}

export function pickNominalCodeForProduct(
  venueProducts = [],
  productId,
  supplierId = '',
) {
  const pid = toId(productId)
  if (!pid) return ''

  const matches = (Array.isArray(venueProducts) ? venueProducts : []).filter(
    vp => toId(vp?.product) === pid,
  )
  if (!matches.length) return ''

  const sid = toId(supplierId)
  if (sid) {
    const exact = matches.find(vp => toId(vp?.supplier) === sid)
    const exactCode = String(exact?.nominalCode || '').trim()
    if (exactCode) return exactCode
  }

  const anySupplier = matches.find(vp => !toId(vp?.supplier))
  const anyCode = String(anySupplier?.nominalCode || '').trim()
  if (anyCode) return anyCode

  const withCode = matches.find(vp => String(vp?.nominalCode || '').trim())
  return String(withCode?.nominalCode || '').trim()
}

/**
 * Ensure each receipting row carries product.nominalCode from shopping-list
 * VenueProducts when the receipting/products API omitted or wiped it.
 */
export function enrichReceiptingRowsWithNominalCodes(
  rows = [],
  venueProducts = [],
  supplierId = '',
) {
  return (Array.isArray(rows) ? rows : []).map(item => {
    const existing = String(
      item?.product?.nominalCode ?? item?.nominalCode ?? '',
    ).trim()
    if (existing) {
      return item?.product && typeof item.product === 'object'
        ? {
            ...item,
            product: { ...item.product, nominalCode: existing },
          }
        : item
    }

    const productId = toId(item?.product)
    const code = pickNominalCodeForProduct(
      venueProducts,
      productId,
      supplierId || toId(item?.supplier),
    )
    if (!code || !item?.product || typeof item.product !== 'object') {
      return item
    }
    return {
      ...item,
      product: {
        ...item.product,
        nominalCode: code,
      },
    }
  })
}
